import { render, staticRenderFns } from "./navigateTo5G.vue?vue&type=template&id=56636ba2&scoped=true&"
import script from "./navigateTo5G.vue?vue&type=script&lang=js&"
export * from "./navigateTo5G.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56636ba2",
  null
  
)

export default component.exports